<template>
  <div>vista detalle insc</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
